import React, { useEffect } from 'react';
import { Outlet } from 'react-router';
import { Card, Container, Row, Col } from 'react-bootstrap';
import CastleLoginBackground from '../../assets/images/CastleLogin_Background.png';
import CastleLogo from '../../assets/images/Logo_Castle.png';
import SmallPlant from '../../assets/images/smallPlant.png';
import './login.scss';
import { Link, useSearchParams } from 'react-router-dom';
import appConfig from '../../app-config';

export default function Login() {
  const [searchParams] = useSearchParams();
  const singleSignOn = searchParams.get('sso');

  useEffect(() => {
    if(singleSignOn === 'NYCAPI'){
      window.location.href = 'https://sso.castlelearning.com/sso/redirect_uri?iss=https://sso.harriscomputer.io/realms/hes&auth_request_params=kc_idp_hint=nycdoe&target_link_uri='+ appConfig.nycRedirectUrl;
    }
  }, []);

  return (
    <Container fluid className="bg">
      <Row style={{flex: '1 0'}}>
        <Col
          className="leftPanel col-md-7 col-lg-7 d-none d-lg-block d-md-block"
          style={{ backgroundImage: `url(${CastleLoginBackground})` }}>
          <Row style={{ fontSize: 'min(2vw, 26px)', fontWeight: '300' }}>Welcome to</Row>
          <Row style={{ fontSize: 'min(3.5vw, 50px)', fontWeight: '800' }}>Castle Learning</Row>

          <Row className="d-flex flex-row mb-3 mt-2">
            {Array.from({ length: 4 }, (_, i) => (
              <div className="square" key={i}></div>
            ))}
          </Row>
          <Row style={{ fontSize: 'min(1vw, 15px)', fontWeight: '400', maxWidth: '470px' }}>
            We provides a wide-range of content specific learning support at every grade level -
            from core subjects to electives.
          </Row>
        </Col>
        <Col className="col-sm-12 col-md-5 col-lg-5" style={{ overflow: 'hidden', height: '100%', marginBottom: '25px' }}>
          <Card className="login-card">
            <Card.Img variant="top" className="login-card-logo" src={CastleLogo} alt="castleLogo" />
            <Outlet />
            <div className="fernImage" style={{ backgroundImage: `url(${SmallPlant})` }}></div>
          </Card>
        </Col>
      </Row>
      <div className="footer" style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ width: '100%' }}>
          &#169; Castle Software, Inc. 2001-{new Date().getFullYear()}
        </div>
        <div style={{ textAlign: 'right', width: '100%' }}>
          <Link
            style={{ textDecoration: 'none' }}
            className='text-color'
            to="https://cl.castlelearning.com/Review/Documents/harristermsofservice.pdf"
            key="termsOfServiceKey"
            target="_blank">
            Terms of Service
          </Link>
          {' | '}
          <Link
            style={{ textDecoration: 'none' }}
            className='text-color'
            to="https://ss-usa.s3.amazonaws.com/c/308482144/media/1765647f827b14a6a87065397081608/Harris%20Education%20Solutions%20Privacy%20Policy%20%282023%20Final%29.pdf"
            key="policyLinkKey"
            target="_blank">
            Privacy Policy
          </Link>
        </div>
      </div>
    </Container>
  );
}
